var $ = require('jquery');
// var styleguide = require('./modules/style-guide.js');
var accordions = require('./modules/accordions.js');
var animations = require('./modules/animations.js');
var cards = require('./modules/cards.js');
var emails = require('./modules/emails.js');
var menu = require('./modules/menu.js');
var sliders = require('./modules/sliders.js');
var menuTabber = require('./modules/menuTabbing.js');
var svg = require('./modules/svg.js');
// Make sure that you init the styleguide first.
// styleguide.init();
accordions.init();
// cards.init();
menuTabber.init();
emails.init();
menu.init();
sliders.init();
svg.init();
animations.init();

var DotLottie = require('@lottiefiles/dotlottie-web');
window.DotLottie = DotLottie.DotLottie;

// Chat Icon
window.onscroll = function(evt) {
    // console.log('Inner height: ' + window.innerHeight + ' Page Y Offset: ' + window.pageYOffset + ' Document offset height: ' + document.body.offsetHeight);
    // if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 80) {
    //     $('#hubspot-messages-iframe-container').addClass('reposition');
    // } else if ((window.innerHeight + window.pageYOffset) < document.body.offsetHeight - 80) {
    //     $('#hubspot-messages-iframe-container').removeClass('reposition');
    // }
};